import { UnavailableReceiptView, ReceiptLineItems } from './components';

export const Receipt = {
  UnavailableView: UnavailableReceiptView,
  LineItems: ReceiptLineItems,
};
